<template>
  <div>
    <Loading :isLoading="isLoading"/>
    <Modal v-if="showModalDescription" :widthContainer="'50%'" :heightContainer="'50%'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#222222;text-align:left;">Descripción</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-1 gap-4" style="border: 1px solid #12B3BD;padding:10px;margin-top:10px;text-align:left;">
            <p>{{descriptionAdded}}</p>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="closeModalDescription()">
      </div>
    </Modal>
    <Modal v-if="showModalListDocuments" :widthContainer="'90% !important'" :heightContainer="'50% !important'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#174a84;">{{modalTitle}}</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-2 gap-4" style="border: 1px solid #12B3BD;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list_filtered" :key="index">
            <div style="">
              <p style="width:70%;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Documento:</p>
              <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:300;">
                {{ `${document.name}.${document.extension}` }}
              </p>
            </div>
            <div>
              <input type="button" value="Eliminar" class="deleteDocumentButton" :id="`delete_document_${document.abbreviation}_${index}`" style="float:right;"
                v-on:click="deleteDocument(document.abbreviation, document.name)">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <Modal v-if="showModal" :widthContainer="'50%'" :heightContainer="'60%'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#222222;text-align:left;">Devolución por: {{conceptSelectedTypeToShow}}</h3>
      <p slot="header" style="font-weight:400;font-size:18px;font-family:Roboto;color:#222222;text-align:left;">
        Las quincenas descontadas deben cumplir con el formato correcto. Ejemplo: <span style="font-weight:500">2021-01</span>
      </p>
      <p slot="header" style="font-weight:400;font-size:18px;font-family:Roboto;color:#222222;text-align:left;">
        Si no se cumple con el formato la quincena no será agregada.
      </p>
      <div slot="body">
        <div class="">
          <form @submit="saveRefund" style="margin-top:10px;">
            <div class="grid md:grid-cols-2 grid-cols-1 gap-4">
              <div>
                <label class="titleInputs" style="display:block;text-align:left;">Importe de devolución:</label>
                <input class="inputsForm" id="input_refund_amount"  type="numeric" style="width:100%;"
                  v-model.trim="$v.refundAmount.$model" 
                  v-money="money"
                  minlength="11" maxlength="11"  min="0"
                  :class="{'inputs-invalid-form':$v.refundAmount.$error, 'inputsForm':!$v.refundAmount.$invalid}">
                <div class="content-text">
                  <div v-if="$v.refundAmount.$error" class="text" style="width:100%;">
                    <span class="errors" v-if="!$v.refundAmount.isUnique">
                      El importe debe estar entre $50.00 y $100,000.00
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <label class="titleInputs" style="display:block;text-align:left;">Quincenas descontadas:</label>
                <vue-tags-input
                  v-model="tagFortnightsDiscounted"
                  v-mask="'####-##'"
                  placeholder="Agregar Etiqueta"
                  :tags="tagsFortnightsDiscounted"
                  :validation="validation"
                  id="input_fortnights_discounted"
                  @tags-changed="newTags => tagsFortnightsDiscounted = newTags"
                />
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4" style="margin-top:30px;">
              <label class="titleInputs" style="display:block;text-align:left;">Descripción:</label>
              <textarea class="inputsForm" style="width:100%;"
                name="" id="textarea_description" cols="30" rows="10"
                v-model.trim="$v.description.$model" 
                :class="{'inputs-invalid-form':$v.description.$error, 'inputsForm':!$v.description.$invalid}">
              </textarea>
              <div class="content-text">
                <div v-if="$v.description.$error" class="text" style="width:100%">
                  <span class="errors" v-if="!$v.description.minLength">Debe ingresar por lo menos 4 caracteres en la descripción</span>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4" style="margin-top:40px;">
              <div>
                <button class="AccessButton" id="button_save_refund_concept">Aceptar</button>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4" style="margin-top:10px;">
              <div>
                <input type="button" value="Cancelar" id="button_cancel_refund_concept"
                  v-on:click="closeAddRefundModalWindow()" class="AccessButtonWithoutBackground">        
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
    <div style="margin-top:30px;">
      <Access ref="accessComponent" :tokenAuth="token_auth" :askNip="askNip" :showForm="showFormAccess"
        description="Ingresar los 13 caracteres del R.F.C. y tu NIP para solicitar tu Solicitud de Reembolso." v-on:search-info-by-rfc-nip="getResponseAccess($event)"/>
    </div>
    <form @submit="register" v-if="rfcIsValid">
      <div style="margin-top:30px;">
        <div>
          <PersonalInfo title="Datos personales del Socio" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfcToShow" />
        </div>
        <div style="margin-top:30px;">
          <div style="margin-top:20px;" class="content-text">
            <div class="text">
              <p class="personalInfoTitle" v-if="hasPendingRequest">Usted ya cuenta con una solicitud de Reembolso.</p>
              <p class="personalInfoTitle" v-if="!hasPendingRequest">Completa los datos que se solicitan para obtener tu Reembolso:</p>
            </div>
          </div>
          <div class="mb-4" style="margin-top:20px;">
            <div class="form-group">
              <input class="inputsForm" id="input_email" type="email" v-model.trim="$v.email.$model" 
                :disabled="hasPendingRequest"
                :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" placeholder="Correo Electrónico">
              <div class="content-text">
                <div v-if="$v.email.$error" class="text">
                  <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                  <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm" id="input_cellphone"  type="text" placeholder="Celular" 
              :disabled="hasPendingRequest"
              minlength="12" maxlength="12"  min="0" v-mask="'### ###-####'" v-model.trim="$v.cellphone.$model" 
              :class="{'inputs-invalid-form':$v.cellphone.$error, 'inputsForm':!$v.cellphone.$invalid}">
            <div class="content-text">
              <div v-if="$v.cellphone.$error" class="text">
                <span class="errors" v-if="!$v.cellphone.required">El celular es requerido</span>
                <span class="errors" v-if="!$v.cellphone.minLength">Debe ingresar los 10 dígitos del celular</span>
                <span class="errors" v-if="!$v.cellphone.maxLength">Debe ingresar los 10 dígitos del celular</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm" id="input_interbank_clabe" type="text" 
              :disabled="hasPendingRequest" v-model.trim="$v.interbankClabe.$model" placeholder="Clabe Interbancaria"
              :class="{'inputs-invalid-form':$v.interbankClabe.$error, 'inputsForm':!$v.interbankClabe.$invalid}" v-mask="'##################'">
            <div class="content-text">
              <div v-if="$v.interbankClabe.$error" class="text">
                <span class="errors" v-if="!$v.interbankClabe.required">La clabe interbancaria es requerida</span>
                <span class="errors" v-if="!$v.interbankClabe.minLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
                <span class="errors" v-if="!$v.interbankClabe.maxLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <select class="inputsForm" id="select_bank" v-model.trim="$v.bank.$model"
              :disabled="hasPendingRequest"
              :class="{'inputs-invalid-form':$v.bank.$error, 'inputsForm':!$v.bank.$invalid}">
              <option value="Banco" selected hidden>Banco</option>
              <option v-for="bank in list_banks" :key="bank.id" :value="bank.name">{{bank.name}}</option>
            </select>
            <div class="content-text">
              <div v-if="$v.bank.$error" class="text">
                <span class="errors" v-if="!$v.bank.isUnique">El banco es requerido</span>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:60px;">
          <div>
            <p class="titleComponent">Concepto de Devolución</p>
            <p class="personalInfoTitle">Seleccione los conceptos donde se realizó un descuento indebido:</p>
          </div>
        </div>
        <div style="margin-top:30;">
          <div class="containerLoanTypeButtons">
            <div class="contentLoanTypeButtons">
              <div v-for="(item, i) in refundConcepts" :key="i">
                <button type="button" :value="item.name" style="cursor:pointer;"
                  :id="`concept_${item.type}`"
                  :disabled="hasPendingRequest"
                  v-on:click="openModalWindowRefund(item)"
                  v-bind:style="{
                    backgroundColor: item.selected  ? activeColorBackground : inactiveColorBackground, 
                    color: item.selected ? activeColorText : inactiveColorText
                  }" class="optionButton">{{item.name}}</button>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:60px;" v-if="refundConceptsSelected.length > 0">
          <div class="content-text">
            <div class="text">
              <p class="titleComponent">Resumen</p>
              <p class="personalInfoTitle" v-if="!hasPendingRequest">Si desea actualizar la información de un concepto necesitará eliminarlo de esta sección  <span style="font-weight:700">(Resumen)</span> y agregarlo de nuevo con la información actualizada.</p>
            </div>
          </div>
          <div class="contentLoadDocumentTable">
            <table class="table loadDocumentTable">
              <thead>
                <tr>
                  <th>Resumen</th>
                  <th></th>
                  <th style="text-align:center;">Importe Solicitado</th>
                  <th></th>
                  <th v-if="!hasPendingRequest"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in refundConceptsSelected" :key="i">
                  <td style="vertical-align:middle;">{{item.concept_name}}</td>
                  <td></td>
                  <td style="text-align:center;vertical-align:middle;">{{item.refund_amount | currency}}</td>
                  <td style="vertical-align:middle;">
                    <svg v-if="item.description != ''" v-on:click="showDescriptionAdded(item.description)" style="cursor:pointer;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 58 58">
                      <defs>
                        <filter id="Rectangle_425" x="0" y="0" width="58" height="58" filterUnits="userSpaceOnUse">
                          <feOffset dy="3" input="SourceAlpha"/>
                          <feGaussianBlur stdDeviation="3" result="blur"/>
                          <feFlood flood-opacity="0.161"/>
                          <feComposite operator="in" in2="blur"/>
                          <feComposite in="SourceGraphic"/>
                        </filter>
                      </defs>
                      <g id="Group_2945" data-name="Group 2945" transform="translate(-1229 -2106)">
                        <g transform="matrix(1, 0, 0, 1, 1229, 2106)" filter="url(#Rectangle_425)">
                          <rect id="Rectangle_425-2" data-name="Rectangle 425" width="40" height="40" rx="5" transform="translate(9 6)" fill="#fff"/>
                        </g>
                        <g id="chat-comment-oval-speech-bubble-with-text-lines_icon-icons.com_73302" transform="translate(1243.635 2117.635)">
                          <g id="_x32__26_">
                            <g id="Group_2939" data-name="Group 2939">
                              <path id="Path_3" data-name="Path 3" d="M18.853,15.262H9.876a.9.9,0,1,0,0,1.8h8.978a.9.9,0,1,0,0-1.8Zm1.8-5.387H8.08a.9.9,0,0,0,0,1.8H20.649a.9.9,0,1,0,0-1.8ZM14.365,0C6.432,0,0,5.627,0,12.569a12.031,12.031,0,0,0,5.387,9.8v6.357l6.293-3.818a16.473,16.473,0,0,0,2.685.227c7.934,0,14.365-5.627,14.365-12.569S22.3,0,14.365,0Zm0,23.342a14.529,14.529,0,0,1-3.035-.329L7.1,25.554,7.16,21.39A10.41,10.41,0,0,1,1.8,12.569C1.8,6.619,7.423,1.8,14.365,1.8S26.934,6.619,26.934,12.569,21.306,23.342,14.365,23.342Z" fill="#179099"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </td>
                  <td style="vertical-align:middle;" v-if="!hasPendingRequest"><DeleteButton :id="`concept_selected_${item.concept_name}`" v-on:click-event-delete-button="getEventClickDeleteButton($event)"
                        :argument="item" />
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="text-align:center;font-weight:700;">Total</td>
                  <td style="text-align:center;font-weight:700;">{{getTotalRefundSelected() | currency}}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="margin-top:30px;" v-if="!hasPendingRequest">
          <div>
            <p class="titleComponent">Cargar Documentos</p>
          </div>
          <div class="contentLoadDocumentTable">
            <table class="table loadDocumentTable">
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Estatus</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in documentsRequired" :key="item.id">
                  <td>{{changeNameDocument(item.name)}}</td>
                  <td>
                    <Check v-show="item.documentAttached" />
                  </td>
                  <td style="width:40%;">
                    <input v-if="!item.documentAttached && item.max_documents_required == 1"
                      type="button" value="Cargar" :id="`button_load_document_${item.abbreviation}`" class="loadDocumentButton" v-on:click="getFile(`input_file_upload_${item.abbreviation}`)">
                    <input v-if="item.max_documents_required > 1"
                      type="button" value="Cargar" :id="`button_load_document_${item.abbreviation}`" class="loadDocumentButton" v-on:click="getFile(`input_file_upload_${item.abbreviation}`)">
                    <input v-show="item.documentAttached" 
                      type="button" value="Detalle de Documentos" :id="`button_detail_${item.abbreviation}`" class="loadDocumentButtonWithoutBackground"
                      v-on:click="filterDocumentList(item.abbreviation, item.name)" style="margin-top:5px;" />
                    <div style='height: 0px;width:0px; overflow:hidden;'><input :id="`input_file_upload_${item.abbreviation}`" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, item.abbreviation, item.name)"/></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="margin-top:30px">
          <div v-show="hasPendingRequest">
            <input type="button" value="Cancelar Solicitud" v-on:click="cancelRequest()" class="AccessButton" id="button_cancel" />
          </div>
          <div v-show="!hasPendingRequest">
            <button class="AccessButton" id="button_save">Solicitar</button>
          </div>
          <div style="margin-top:10px">
            <div>
              <input type="button" value="Atrás" v-on:click="goBack()" class="AccessButtonWithoutBackground" id="backButton">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import User from '@/classes/User';
import Document from '@/classes/Document';
import Refund from '@/classes/Refund';
import { getBanks } from "@/api/bank";

import Check from '@/components/Loading/Check.vue'
import Loading from '@/components/Loading/Loading.vue'
import Modal from '@/components/Modal/Modal.vue'
import Access from '@/components/Forms/Access.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'
import DeleteButton from '@/components/Button/DeleteButton/DeleteButton.vue'

import {validateEmail} from '@/helpers/email'
import {required, minLength, maxLength, email} from 'vuelidate/lib/validators'
import VueTagsInput from '@johmun/vue-tags-input';
import {VMoney} from 'v-money'

import('@/assets/css/stylesheet.css')
import('@/assets/css/tags.css')

export default {
  data() {
    return {
      userObjectClass: null,
      documentObjectClass: null,
      refundObjectClass: null,
      isLoading: false,
      token_auth: "",
      askNip: true,
      showFormAccess: true,
      list_banks: [],
      bank: "Banco",
      email: "",
      interbankClabe: "",
      cellphone: "",
      name: "",
      paternalName: "",
      maternalName: "",
      refundAmount: 5000,
      description: "",
      rfcToShow: "",
      rfcIsValid: false,
      refundConcepts: [],
      refundConceptsSelected: [],
      conceptSelectedType: "",
      conceptSelectedTypeToShow: "",
      documentsRequired: [],
      documentValidations: [],
      showModalListDocuments: false,
      showModalDescription: false,
      descriptionAdded: "",
      documents_list: [],
      documents_list_filtered: [],
      activeLoanTypeItem: "ordinario",
      activeColorBackground: "#198F99",
      inactiveColorBackground: "#fff",
      activeColorText: "#fff",
      inactiveColorText: "#198F99",
      showModal: false,
      tagFortnightsDiscounted: '',
      tagsFortnightsDiscounted: [],
      hasPendingRequest: false,
      requestId: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      autocompleteItems: [{
        text: 'Spain',
      }],
      validation: [{
        classes: 'min-length',
        rule: tagFortnightsDiscounted => tagFortnightsDiscounted.text.length < 7,
        disableAdd: true,
      }],
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  directives: {money: VMoney},
  validations: {
    email: {
      required,
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    cellphone: {
      required,
      minLength: minLength(12),
      maxLength: maxLength(12)
    },
    interbankClabe: {
      required,
      minLength: minLength(18),
      maxLength: maxLength(18)
    },
    bank: {
      required,
      isUnique(value) {
        if (value == "Banco") {
          return false;
        }

        return true;
      }
    },
    refundAmount: {
      required,
      isUnique(value) {
        value = this.convertStringCurrencyToNumber(value);
        if (value >= 50 && value <= 100000) {
          return true;
        }

        return false;
      }
    },
    description: {
      minLength: minLength(4)
    },
  },
  name: 'RefundForDiscountRequestComponent',
  components: {
    Check,
    Loading,
    Modal,
    Access,
    PersonalInfo,
    DeleteButton,
    VueTagsInput
  },
  beforeMount() {
    this.userObjectClass = new User();
    this.documentObjectClass = new Document();
    this.refundObjectClass = new Refund();
    this.login();
    this.createRefundConceptsArray(this.refundObjectClass.typeRefunds);
  },
  methods: {
    showDescriptionAdded(description) {
      this.descriptionAdded = description;
      this.showModalDescription = true;
    },
    saveRefund(e) {
      e.preventDefault();
      if (!this.isInvalidModalRefundForm()) {
        this.addRefundSelected();
        this.changeStyleConceptButtons();
        this.closeAddRefundModalWindow();
      }
    },
    getEventClickDeleteButton(event) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Está seguro de eliminar el reembolso?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.deleteConceptSelected(event.concept_name);
        }
      });

      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    deleteConceptSelected(concept) {
      try {
        let indexRefundConceptsSelected = this.refundConceptsSelected.findIndex(a => a.concept_name === concept);
        let indexRefundConcepts = this.refundConcepts.findIndex(a => a.name === concept);
        this.refundConceptsSelected.splice(indexRefundConceptsSelected, 1);
        this.refundConcepts[indexRefundConcepts].selected = false; 
      } catch (error) {
        Swal.fire({
          title: "Aviso",
          text: "Error al eliminar concepto",
          icon: "error",
        });
      }
    },
    changeStyleConceptButtons() {
      let index = this.refundConcepts.findIndex(a => a.name === this.conceptSelectedTypeToShow);
      this.refundConcepts[index].selected = !this.refundConcepts[index].selected;
    },
    addRefundSelected() {
      let object = {
        concept_name: this.conceptSelectedTypeToShow,
        refund_amount: this.convertStringCurrencyToNumber(this.refundAmount),
        fortnights_to_return: this.getFortnightsDiscountedTags(),
        description: this.description
      }

      this.refundConceptsSelected.push(object);
    },
    async register(e) {
      e.preventDefault();
      
      if (!this.isInvalidPrincipalRefundForm()) {
        this.isLoading = true;
        let isThereASelectedConcept = this.isThereASelectedConcept();
        if (!isThereASelectedConcept) {
          this.isLoading = false;
          return;
        }

        let documentsComplete = this.areDocumentsComplete();
        if (!documentsComplete) {
          this.isLoading = false;
          return;
        }

        let json = this.createObjectToCreateRefundForDiscountRequest();

        try {
          let response = await this.refundObjectClass.save(json);
          this.isLoading = false;
          this.cleanAllControls();

          Swal.fire({
            text: "Solicitud de Reembolso Por Descuentos Indebidos",
            html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Retiro de Reembolso guardada correctamente</p><br/>
                  <p style="font-size:14px;">Todas las solicitudes capturadas a través de esta página, 
                  serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
            //this.$router.push({ name: 'HomeLoanRequest' });
          });
        } catch (error) {
          this.isLoading = false;
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        }
      }
    },
    isInvalidPrincipalRefundForm() {
      this.$v.email.$touch();
      this.$v.cellphone.$touch();
      this.$v.interbankClabe.$touch();
      this.$v.bank.$touch();

      if (!this.$v.email.$invalid || !this.$v.cellphone.$invalid || !this.$v.interbankClabe.$invalid
          || !this.$v.bank.$invalid) {
        return false;
      }

      return true;
    },
    isInvalidModalRefundForm() {
      this.$v.refundAmount.$touch();
      this.$v.description.$touch();
      if (!this.$v.refundAmount.$invalid && !this.$v.description.$invalid) {
        return false;
      }

      return true;
    },
    createRefundConceptsArray(concepts) {
      this.refundConcepts = [];
      concepts.forEach(element => {
        this.refundConcepts.push({
          name: element.name,
          type: element.type,
          selected: false
        })
      });
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
        this.getBanks();
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getBanks() {
      getBanks(this.token_auth).then(response => {
        this.list_banks = response.data.response.lista_bancos;
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    setAuthenticatedUserInformation(userAuthenticated) {
      this.name = userAuthenticated.name;
      this.paternalName = userAuthenticated.paternal_name;
      this.maternalName = userAuthenticated.maternal_name;
      this.rfcToShow = userAuthenticated.rfc;
    },
    getResponseAccess(event){
      if (event.rfcIsValid) {
        this.showFormAccess = false;
        this.setAuthenticatedUserInformation(event.data);
        this.getDocumentsRequired();
        this.getRefundForDiscountRequest();
      }
      this.rfcIsValid = event.rfcIsValid;
    },
    closeAddRefundModalWindow() {
      this.cleanAllControlsRefundInModalWindow();
      this.showModal = false;
    },
    closeModalDescription() {
      this.showModalDescription = false;
      this.descriptionAdded = "";
    },
    cleanAllControlsRefundInModalWindow() {
      this.refundAmount = 5000;
      this.description = "";
      this.tagFortnightsDiscounted = "";
      this.tagsFortnightsDiscounted = [];
      this.$v.refundAmount.$reset();
      this.$v.description.$reset();
    },
    cleanAllControls() {
      this.requestId = 0;
      this.hasPendingRequest = false;
      this.rfcToShow = "";
      this.rfcIsValid = false;
      this.showFormAccess = true;
      this.email = "";
      this.cellphone = "";
      this.interbankClabe = "";
      this.bank = "Banco";
      this.documents_list = [];
      this.documents_list_filtered = [];
      this.refundConceptsSelected = [];
      this.$v.$reset()
      this.createRefundConceptsArray(this.refundObjectClass.typeRefunds);
    },
    convertStringCurrencyToNumber(currency) {
      return Number(currency.toString().replace(/[^0-9.]+/g,""));
    },
    openModalWindowRefund(concept) {
      let index = this.refundConcepts.findIndex(a => a.type === concept.type);

      if (index != -1) {
        if (this.refundConcepts[index].selected) {
          Swal.fire({
            title: "Aviso",
            html: `<p style="font-size:14px;font-family:Roboto;">El concepto que intenta seleccionar ya ha sido seleccionado, 
                    si desea actualizar la información favor de eliminarlo de la sección de <span style="font-weight:700;">Resumen</span> y agregarlo de nuevo.</p>`,
            icon: "info",
          }); 
        } else {
          this.showModal = true;
          this.conceptSelectedType = concept.type;
          this.conceptSelectedTypeToShow = concept.name;
        }
      } else {
        
      }
    },
    getTotalRefundSelected() {
      return this.refundConceptsSelected.map(a => a.refund_amount).reduce((a, b) => a + b, 0);
    },
    async getDocumentsRequired() {
      try {
        let requiredIn = "reembolso por descuento indebido";
        let response = await this.documentObjectClass.getDocumentsRequired(this.token_auth, requiredIn);
        this.documentsRequired = response.data.response.data;
        this.createDocumentsRequiredArray(this.documentsRequired);
      } catch (error) {
        Swal.fire({
          title: "Aviso",
          text: "Error al consultar documentos requeridos",
          icon: "error",
        });
      }
    },
    createDocumentsRequiredArray(documentsRequired) {
      this.documentsRequired = [];
      documentsRequired.forEach(element => {
        this.documentsRequired.push({
          abbreviation: element.abbreviation,
          documentAttached: false,
          max_documents_required: element.max_documents_required,
          id: element.id,
          name: element.name
        })
      });
    },
    getFile(selector) {
      this.documentObjectClass.getFileByIdSelector(selector);
    },
    loadDocument(event, type, typeDescription) {
      let file = event.target.files;
      let filename = file[0].name;
      let extension = file[0].type.split('/')[1];

      if(this.documents_list.length > 0){
        let indexDocumentSelected = this.documentsRequired.findIndex(a => a.abbreviation === type);
        let maxDocumentsRequired = indexDocumentSelected != -1 ? this.documentsRequired[indexDocumentSelected].max_documents_required : 1;

        if (!this.documentTypeReachItsLimit(type, maxDocumentsRequired)) {
          if (this.existDocument(this.documents_list, filename.split('.')[0].replace(/\s/g, '_'))) {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: "El archivo seleccionado ya ha sido cargado",
              icon: "error",
            });
            return;
          }
        } else {
          Swal.fire({
            title: "Aviso",
            text: `Solo puede subir ${maxDocumentsRequired} documentos en el apartado de ${typeDescription}`,
            icon: "error",
          });
          return;
        }
      }

      this.documentObjectClass.serialize(file[0]).then(base64Response => {
        this.setDocumentList(base64Response, filename.split('.')[0].replace(/\s/g, '_'), extension, type);
        this.changeValueChecks(true, type);
        this.showLoadedDocumentSuccessMessage(filename, typeDescription);
      }).catch(error => {
        console.error(error);
      });
    },
    documentTypeReachItsLimit(document, maxDocumentsRequired) {
      let documents = this.documents_list.filter(d => d.abbreviation === document);
      if (documents.length >= maxDocumentsRequired) {
        return true;
      }
      return false;
    },
    existDocument(documents, newDocument) {
      let indexDocuments = documents.findIndex(d => d.name === newDocument);
      if (indexDocuments != -1) {
        return true;
      }
      return false;
    },
    setDocumentList(fileBase64, fileName, extension, abbreviation) {
      this.documents_list.push({
        file: fileBase64,
        name: fileName,
        extension: extension,
        abbreviation: abbreviation
      });
    },
    changeValueChecks(value, document) {
      let index = -1;
      if (!value) {
        index = this.documents_list.findIndex(b => b.abbreviation === document);
        value = index != -1 ? true : value
      }

      let indexDocumentValidations = this.documentsRequired.findIndex(b => b.abbreviation === document);

      if (indexDocumentValidations != -1) {
        this.documentsRequired[indexDocumentValidations].documentAttached = value
      }
    },
    showLoadedDocumentSuccessMessage(documentName, documentType) {
      Swal.fire({
        text: "Solicitud de retiro guardada correctamente",
        html: `<p style="font-size:14px;font-family:Roboto;">El documento: <span style="font-weight:500;">${documentName}</span> se ha adjuntado en el apartado de ${documentType}.</p>`,
        confirmButtonText: "Continuar",
        allowOutsideClick: false,
        icon: "success",
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm', '');
    },
    filterDocumentList(document, modalTitle) {
      this.documents_list_filtered = this.documents_list.filter(b => b.abbreviation === document);
      this.modalTitle = modalTitle;
      this.showModalListDocuments = true;
    },
    deleteDocument(document, documentName){
      Swal.fire({
        title: "Aviso",
        text: '¿Desea eliminar el documento?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          let indexDocuments = this.documents_list.findIndex(d => d.abbreviation === document && d.name === documentName);
          let indexDocumentsFiltered = this.documents_list_filtered.findIndex(d => d.abbreviation === document && d.name === documentName);
          if (indexDocuments != -1) {
            this.documents_list.splice(indexDocuments,1);
            this.changeValueChecks(false, document);
          } 
          if (indexDocumentsFiltered != -1) {
            this.documents_list_filtered.splice(indexDocumentsFiltered,1);
          } 
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    setIdAttributeToAccepAndCancelButtonSwalFire(idButtonConfirm="", idButtonCancel="") {
      if (idButtonConfirm != "") {
        $('.swal2-confirm').attr('id', idButtonConfirm);  
      }
      
      if (idButtonCancel != "") {
        $('.swal2-cancel').attr('id', idButtonCancel); 
      }
    },
    isThereASelectedConcept() {
      if (this.refundConceptsSelected.length <= 0) {
        Swal.fire({
          title: "Aviso",
          text: "Favor de seleccionar un Concepto de Devolución.",
          icon: "warning",
        })

        return false;
      }

      return true;
    },
    areDocumentsComplete() {
      if (this.documentsRequired.length > 0) {
        let documentValidationsFiltered = this.documentsRequired.filter(a => !a.documentAttached);

        if (documentValidationsFiltered.length > 0) {
          Swal.fire({
            title: "Aviso",
            text: "Favor de completar la carga de documentos.",
            icon: "warning",
          })
          return false;
        }  
      } else {
        return false;  
      }
      
      return true;
    },
    getFortnightsDiscountedTags() {
      if (this.tagsFortnightsDiscounted.length > 0) {
        return this.tagsFortnightsDiscounted.map(x => x.text).join(', ');
      }

      return "";
    },
    async getRefundForDiscountRequest() {
      try {
        let response = await this.refundObjectClass.getByRfc(this.token_auth, this.rfcToShow);
        console.log(response.data.response.undue_discount_request);
        if (response.data.response.undue_discount_request.length > 0) {
          let pendingRequest = response.data.response.undue_discount_request.filter(b => b.status === "pendiente");
          this.hasPendingRequest = pendingRequest.length > 0 ? true : false;
          if (this.hasPendingRequest) {
            this.setRefundForDiscountRequested(pendingRequest[0]);
          }
          console.log("request: ", response.data.response.undue_discount_request); 
        }
      } catch (error) {
        
      }
    },
    setRefundForDiscountRequested(json) {
      this.requestId = json.id;
      this.email = json.email;
      this.cellphone = json.cellphone;
      this.interbankClabe = json.interbank_clabe;
      this.refundConceptsSelected = json.concepts;

      this.refundConceptsSelected.forEach(element => {
        this.conceptSelectedTypeToShow = element.concept_name;
        this.changeStyleConceptButtons();
      });
    },
    createObjectToCreateRefundForDiscountRequest() {
      let json = {
        token_auth: this.token_auth,
        rfc: this.rfcToShow,
        email: this.email,
        cellphone: this.removeMask(this.cellphone),
        interbank_clabe: this.interbankClabe,
        bank_name: this.bank,
        concepts: this.refundConceptsSelected,
        document_list: this.documents_list
      }
      console.log("create: ", json);
      return json;
    },
    removeMask(phone) {
      if (phone.includes("(")) {
        phone = phone.replace("(", "");
      }
      if (phone.includes(")")) {
        phone = phone.replace(")", "");
      }
      if (phone.includes("-")) {
        phone = phone.replace("-", "");
      }
      if (phone.includes(" ")) {
        phone = phone.replace(" ", "");
      }
      return phone;
    },
    cancelRequest() {
      Swal.fire({
        title: "Aviso",
        text: '¿Desea cancelar su Solicitud de Reembolso?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.refundObjectClass.cancel(this.token_auth, this.requestId).then(response => {
            this.isLoading = false;
            this.cleanAllControls();
            Swal.fire({
              html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Reembolso cancelada correctamente</p>`,
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              icon: "success",
            }).then((response)=>{
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            });
          });
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    goBack() {
      this.cleanAllControls();
    },
    changeNameDocument(abbreviation){
      switch (abbreviation) {
        case "Identificación oficial":
            return "INE/IFE"
        default:
          return abbreviation
      }
    }
  }
}
</script>